// define all localStorage keys here to avoid key collisions

export enum LocalStorageKeys {
  AUTH0_LOGIN_ERROR = 'AUTH0_LOGIN_ERROR',
  ACCESS_TOKEN = 'ACCESS_TOKEN',
  MAGIC_LINK_ORIGINAL_ROUTE = 'MAGIC_LINK_ORIGINAL_ROUTE',
  AGENTS_TABLE_PREFERENCES = 'AGENTS_TABLE_PREFERENCES',
  ALERTS_TABLE_PREFERENCES = 'ALERTS_TABLE_PREFERENCES',
  ENTITY_CENTRIC_TABLE_PREFERENCES = 'ENTITY_CENTRIC_TABLE_PREFERENCES',
  CASES_TABLE_PREFERENCES = 'CASES_TABLE_PREFERENCES',
  DM_TABLE_PREFERENCES = 'DM_TABLE_PREFERENCES',
  DOCUMENTS_TABLE_PREFERENCES = 'DOCUMENTS_TABLE_PREFERENCES',
  SAR_TABLE_PREFERENCES = 'SAR_TABLE_PREFERENCES',
  DOEP_TABLE_PREFERENCES = 'DOEP_TABLE_PREFERENCES',
  TEAMS_TABLE_PREFERENCES = 'TEAMS_TABLE_PREFERENCES',
  ALERT_AI_AGENTS_TABLE_PREFERENCES = 'AI_AGENTS_TABLE_PREFERENCES',
  CASE_AI_AGENTS_TABLE_PREFERENCES = 'CASE_AI_AGENTS_TABLE_PREFERENCES',
  FILING_AI_AGENTS_TABLE_PREFERENCES = 'FILING_AI_AGENTS_TABLE_PREFERENCES',
  ALERT_AI_AGENTS_FILTERS = 'AI_AGENTS_FILTERS',
  CASE_AI_AGENTS_FILTERS = 'CASE_AI_AGENTS_FILTERS',
  FILING_AI_AGENTS_FILTERS = 'FILING_AI_AGENTS_FILTERS',
  AI_AGENTS_PINNED_FILTERS = 'AI_AGENTS_PINNED_FILTERS',
  ALERT_AI_AGENT_DETAILS_SIDE_PANEL = 'ALERT_AI_AGENT_DETAILS_SIDE_PANEL',
  CASE_AI_AGENT_DETAILS_SIDE_PANEL = 'CASE_AI_AGENT_DETAILS_SIDE_PANEL',
  FILING_AI_AGENT_DETAILS_SIDE_PANEL = 'FILING_AI_AGENT_DETAILS_SIDE_PANEL',
  ALERTS_GROUP_BY_PREFERENCES = 'ALERTS_GROUP_BY_PREFERENCES',
  FINCEN_CTR_GROUP_BY_PREFERENCES = 'FINCEN_CTR_GROUP_BY_PREFERENCES',
  MY_FINCEN_CTR_PINNED_FILTERS = 'MY_FINCEN_CTR_PINNED_FILTERS',
  QUEUED_FINCEN_CTR_PINNED_FILTERS = 'QUEUED_FINCEN_CTR_PINNED_FILTERS',
  ADMIN_FINCEN_CTR_PINNED_FILTERS = 'ADMIN_FINCEN_CTR_PINNED_FILTERS',
  QUEUE_DETAILS_FINCEN_CTR_PINNED_FILTERS = 'QUEUE_DETAILS_FINCEN_CTR_PINNED_FILTERS',
  MY_FINCEN_CTR_FILTERS = 'MY_FINCEN_CTR_FILTERS',
  QUEUED_FINCEN_CTR_FILTERS = 'QUEUED_FINCEN_CTR_FILTERS',
  ADMIN_FINCEN_CTR_FILTERS = 'ADMIN_FINCEN_CTR_FILTERS',
  QUEUE_DETAILS_FINCEN_CTR_FILTERS = 'QUEUE_DETAILS_FINCEN_CTR_FILTERS',
  ENTITY_CENTRIC_SORT_BY_PREFERENCES = 'ENTITY_CENTRIC_SORT_BY_PREFERENCES',
  WATCHLIST_RESULT_TABLE_PREFERENCES = 'WATCHLIST_RESULT_TABLE_PREFERENCES',
  MY_ALERT_FILTERS = 'MY_ALERT_FILTERS',
  QUEUED_ALERT_FILTERS = 'QUEUED_ALERT_FILTERS',
  ADMIN_ALERT_FILTERS = 'ADMIN_ALERT_FILTERS',
  ALERT_QUEUE_ALERT_FILTERS = 'ALERT_QUEUE_ALERT_FILTERS',
  TXN_ANALYSIS_FILTERS = 'TXN_ANALYSIS_FILTERS',
  TXN_ANALYSIS_TABLE_PREFERENCES = 'TXN_ANALYSIS_TABLE_PREFERENCES',
  MY_CASE_FILTERS = 'MY_CASE_FILTERS',
  QUEUED_CASE_FILTERS = 'QUEUED_CASE_FILTERS',
  ADMIN_CASE_FILTERS = 'ADMIN_CASE_FILTERS',
  CASE_QUEUE_CASE_FILTERS = 'CASE_QUEUE_CASE_FILTERS',
  ALERT_PINNED_FILTERS = 'ALERT_PINNED_FILTERS',
  ALERT_PINNED_SAVED_FILTERS = 'ALERT_PINNED_SAVED_FILTERS',
  CASE_PINNED_FILTERS = 'CASE_PINNED_FILTERS',
  ENTITY_DETAILS_SIDE_PANEL = 'ENTITY_DETAILS_SIDE_PANEL',
  INSTRUMENT_DETAILS_SIDE_PANEL = 'INSTRUMENT_DETAILS_SIDE_PANEL',
  ENTITY_DETAILS_TXN_FILTERS = 'ENTITY_DETAILS_TXN_FILTERS',
  INSTRUMENT_DETAILS_TXN_FILTERS = 'INSTRUMENT_DETAILS_TXN_FILTERS',
  ENTITY_DETAILS_TXN_PINNED_FILTERS = 'ENTITY_DETAILS_TXN_PINNED_FILTERS',
  INSTRUMENT_DETAILS_TXN_PINNED_FILTERS = 'INSTRUMENT_DETAILS_TXN_PINNED_FILTERS',
  ENTITY_DETAILS_TXN_TABLE_PREFERENCES = 'ENTITY_DETAILS_TXN_TABLE_PREFERENCES',
  INSTRUMENT_DETAILS_TXN_TABLE_PREFERENCES = 'INSTRUMENT_DETAILS_TXN_TABLE_PREFERENCES',
  INSTRUMENT_DETAILS_RULES_TABLE_PREFERENCES = 'INSTRUMENT_DETAILS_RULES_TABLE_PREFERENCES',
  ENTITY_DETAILS_EVENT_FILTERS = 'ENTITY_DETAILS_EVENT_FILTERS',
  ENTITY_DETAILS_EVENT_PINNED_FILTERS = 'ENTITY_DETAILS_EVENT_PINNED_FILTERS',
  ENTITY_DETAILS_EVENT_TABLE_PREFERENCES = 'ENTITY_DETAILS_EVENT_TABLE_PREFERENCES',
  ENTITY_RISK_ALERT_TABLE_PREFERENCES = 'ENTITY_RISK_ALERT_TABLE_PREFERENCES',
  ENTITY_RISK_SAR_TABLE_PREFERENCES = 'ENTITY_RISK_SAR_TABLE_PREFERENCES',
  ENTITY_RISK_CASE_TABLE_PREFERENCES = 'ENTITY_RISK_CASE_TABLE_PREFERENCES',
  ENTITY_DETAILS_RULES_TABLE_PREFERENCES = 'ENTITY_DETAILS_RULES_TABLE_PREFERENCES',
  RISK_MODEL_SIDE_PANEL = 'RISK_MODEL_SIDE_PANEL',
  OVERRIDDEN_ENTITIES_TABLE_PREFERENCES = 'OVERRIDDEN_ENTITIES_TABLE_PREFERENCES',
  SAR_FILING_SIDE_PANEL = 'SAR_FILING_SIDE_PANEL',
  CTR_FILING_SIDE_PANEL = 'CTR_FILING_SIDE_PANEL',
  SAR_SUS_ACTS_ALL_SHOWN = 'SAR_SUS_ACTS_ALL_SHOWN',
  ENTITY_TABLE_PREFERENCES = 'ENTITY_TABLE_PREFERENCES',
  ENTITY_FILTERS = 'ENTITY_FILTERS',
  ENTITY_PINNED_FILTERS = 'ENTITY_PINNED_FILTERS',
  INSTRUMENT_TABLE_PREFERENCES = 'INSTRUMENT_TABLE_PREFERENCES',
  INSTRUMENT_RISK_ALERT_TABLE_PREFERENCES = 'INSTRUMENT_RISK_ALERT_TABLE_PREFERENCES',
  INSTRUMENT_RISK_CASE_TABLE_PREFERENCES = 'INSTRUMENT_RISK_CASE_TABLE_PREFERENCES',
  SETTINGS_EXPORT_IMPORT_SIDEPANEL = 'SETTINGS_EXPORT_IMPORT_SIDEPANEL',
  INSTRUMENT_FILTERS = 'INSTRUMENT_FILTERS',
  INSTRUMENT_PINNED_FILTERS = 'INSTRUMENT_PINNED_FILTERS',
  TRANSACTION_TABLE_PREFERENCES = 'TRANSACTION_TABLE_PREFERENCES',
  TRANSACTION_FILTERS = 'TRANSACTION_FILTERS',
  TRANSACTION_PINNED_FILTERS = 'TRANSACTION_PINNED_FILTERS',
  ACTION_EVENT_TABLE_PREFERENCES = 'ACTION_EVENT_TABLE_PREFERENCES',
  ACTION_EVENT_FILTERS = 'ACTION_EVENT_FILTERS',
  ACTION_EVENT_PINNED_FILTERS = 'ACTION_EVENT_PINNED_FILTERS',
  ACTION_MAPPING_PINNED_FILTERS = 'ACTION_MAPPING_PINNED_FILTERS',
  LIVE_RULE_FILTERS = 'LIVE_RULE_FILTERS',
  VALIDATING_RULE_FILTERS = 'VALIDATING_RULE_FILTERS',
  SHADOW_RULE_FILTERS = 'SHADOW_RULE_FILTERS',
  RULE_PINNED_FILTERS = 'RULE_PINNED_FILTERS',
  MY_FILING_FILTERS = 'MY_FILING_FILTERS',
  QUEUED_FILING_FILTERS = 'QUEUED_FILING_FILTERS',
  ADMIN_FILING_FILTERS = 'ADMIN_FILING_FILTERS',
  FILING_QUEUE_FILING_FILTERS = 'FILING_QUEUE_FILING_FILTERS',
  FILING_PINNED_FILTERS = 'FILING_PINNED_FILTERS',
  QUALITY_CYCLE_TABLE_PREFERENCES = 'QUALITY_CYCLE_TABLE_PREFERENCES',
  AGENT_FILTERS = 'AGENT_FILTERS',
  AGENT_PINNED_FILTERS = 'AGENT_PINNED_FILTERS',
  DATA_SETTING_PINNED_FILTERS = 'DATA_SETTING_PINNED_FILTERS',
  DATA_SETTINGS_FILTERS = 'DATA_SETTINGS_FILTERS',
  STREAM_FILTERS = 'STREAM_FILTERS',
  STREAM_PINNED_FILTERS = 'STREAM_PINNED_FILTERS',
  TEAM_AGENT_PINNED_FILTERS = 'TEAM_AGENT_PINNED_FILTERS',
  WATCHLIST_FILTERS = 'WATCHLIST_FILTERS',
  ALERT_TRANSACTION_TABLE_PREFERENCES = 'ALERT_TRANSACTION_TABLE_PREFERENCES',
  SEARCH_ENTITY_ID_EXACT_MATCH = 'SEARCH_ENTITY_ID_EXACT_MATCH',
  LAST_ROUTE = 'last-route',
  LAST_SURVEY_TIMESTAMP = 'LAST_SURVEY_TIMESTAMP',
  FRAUD_DASHBOARD_FILTERS = 'FRAUD_DASHBOARD_FILTERS',
  ALERT_DETAILS_SIDE_PANEL = 'ALERT_DETAILS_SIDE_PANEL',
  CASE_DETAILS_SIDE_PANEL = 'CASE_DETAILS_SIDE_PANEL',
  GLOBAL_SEARCH_OPTION = 'GLOBAL_SEARCH_OPTION',
  FINCEN_314A_PERSON_SCAN_TABLE_PREFERENCES = 'FINCEN_314A_PERSON_SCAN_TABLE_PREFERENCES',
  FINCEN_314A_BUSINESS_SCAN_TABLE_PREFERENCES = 'FINCEN_314A_BUSINESS_SCAN_TABLE_PREFERENCES',
  FINCEN_314A_SCAN_ALERTS_TABLE_PREFERENCES = 'FINCEN_314A_SCAN_ALERTS_TABLE_PREFERENCES',
  REPORT_DASHBOARDS_CONFIG = 'REPORT_DASHBOARDS_CONFIG',
  INSTRUMENT_CENTRIC_TABLE_PREFERENCES = 'INSTRUMENT_CENTRIC_TABLE_PREFERENCES',
  INSTRUMENT_CENTRIC_SORT_BY_PREFERENCES = 'INSTRUMENT_CENTRIC_SORT_BY_PREFERENCES',
  AI_ADMIN_TRACKING_TABLE_PREFERENCES = 'AI_ADMIN_TRACKING_TABLE_PREFERENCES',
  AI_ADMIN_TRACKING_FILTERS = 'AI_ADMIN_TRACKING_FILTERS',
  AI_ADMIN_TRACKING_PINNED_FILTERS = 'AI_ADMIN_TRACKING_PINNED_FILTERS',
  MATCHLIST_TABLE_PREFERENCES = 'MATCHLIST_TABLE_PREFERENCES',
  PROGRAM_EFFICIENCY_ALERT_DASHBOARD_FILTERS = 'PROGRAM_EFFICIENCY_ALERT_DASHBOARD_FILTERS',
  PROGRAM_EFFICIENCY_ALERT_DASHBOARD_PINNED_FILTERS = 'PROGRAM_EFFICIENCY_ALERT_DASHBOARD_PINNED_FILTERS',
  PROGRAM_EFFICIENCY_CASE_DASHBOARD_FILTERS = 'PROGRAM_EFFICIENCY_CASE_DASHBOARD_FILTERS',
  PROGRAM_EFFICIENCY_CASE_DASHBOARD_PINNED_FILTERS = 'PROGRAM_EFFICIENCY_CASE_DASHBOARD_PINNED_FILTERS',
  PROGRAM_EFFICIENCY_SAR_DASHBOARD_FILTERS = 'PROGRAM_EFFICIENCY_SAR_DASHBOARD_FILTERS',
  PROGRAM_EFFICIENCY_SAR_DASHBOARD_PINNED_FILTERS = 'PROGRAM_EFFICIENCY_SAR_DASHBOARD_PINNED_FILTERS',
  G2_REVIEW_LAST_OPEN_TIME = 'G2_REVIEW_LAST_OPEN_TIME',
  ALERT_NOTES_SORT_ORDER = 'ALERT_NOTES_SORT_ORDER',
  ALERT_COMMENTS_SORT_ORDER = 'ALERT_COMMENTS_SORT_ORDER',
  CASE_NOTES_SORT_ORDER = 'CASE_NOTES_SORT_ORDER',
  CASE_COMMENTS_SORT_ORDER = 'CASE_COMMENTS_SORT_ORDER',
  RULE_NOTES_SORT_ORDER = 'RULE_NOTES_SORT_ORDER',
  FINTRAC_STR_SIDE_PANEL = 'FINTRAC_STR_SIDE_PANEL',
  FINTRAC_STR_TABLE_PREFERENCES = 'FINTRAC_STR_TABLE_PREFERENCES',
  FINCEN_DOEP_SIDE_PANEL = 'FINCEN_DOEP_SIDE_PANEL',
  ALERT_AI_AGENT_TASKS_CLOSED_SECTIONS = 'AI_AGENT_TASKS_CLOSED_SECTIONS',
  CASE_AI_AGENT_TASKS_CLOSED_SECTIONS = 'CASE_AI_AGENT_TASKS_CLOSED_SECTIONS',
  FILING_AI_AGENT_TASKS_CLOSED_SECTIONS = 'FILING_AI_AGENT_TASKS_CLOSED_SECTIONS',
  ALERT_AI_AGENT_TASKS_FILTERS = 'AI_AGENT_TASKS_FILTERS',
  CASE_AI_AGENT_TASKS_FILTERS = 'CASE_AI_AGENT_TASKS_FILTERS',
  FILING_AI_AGENT_TASKS_FILTERS = 'FILING_AI_AGENT_TASKS_FILTERS',
  AI_AGENT_TASKS_PINNED_FILTERS = 'AI_AGENT_TASKS_PINNED_FILTERS',
  ALERT_AI_AGENT_ALERT_HISTORY_TABLE = 'AI_AGENT_ALERT_HISTORY_TABLE',
  CASE_AI_AGENT_CASE_HISTORY_TABLE = 'CASE_AI_AGENT_CASE_HISTORY_TABLE',
  FILING_AI_AGENT_FILING_HISTORY_TABLE = 'FILING_AI_AGENT_FILING_HISTORY_TABLE',
  AI_AGENT_NARRATIVE_HIDE_INFO = 'AI_AGENT_NARRATIVE_HIDE_INFO',
  AI_AGENT_TASKS_HIDE_INFO = 'AI_AGENT_TASKS_HIDE_INFO',
  RULE_HEADER_ACTION_SHOW_TOUR = 'RULE_HEADER_ACTION_SHOW_TOUR',
  SEGMENTS_BANNER_HIDDEN = 'SEGMENTS_BANNER_HIDDEN',
  RULE_CREATE_SIDE_PANEL = 'RULE_CREATE_SIDE_PANEL',
  VARIABLE_MODAL_SIDE_PANEL = 'VARIABLE_MODAL_SIDE_PANEL',
  SCHEDULE_TABLE_PREFERENCES = 'SCHEDULE_TABLE_PREFERENCES',
  SCHEDULE_TEAMS_TABLE_PREFERENCES = 'SCHEDULE_TEAMS_TABLE_PREFERENCES',
  SCHEDULE_AGENTS_TABLE_PREFERENCES = 'SCHEDULE_AGENTS_TABLE_PREFERENCES',
  SCHEDULE_AGENTS_PINNED_FILTERS = 'SCHEDULE_AGENTS_PINNED_FILTERS',
  SCHEDULE_AGENTS_FILTERS = 'SCHEDULE_AGENTS_FILTERS',
  WORKFLOW_VISUALIZER_PINNED_FILTERS = 'WORKFLOW_VISUALIZER_PINNED_FILTERS',
  WORKFLOW_VISUALIZER_AUTO_ARRANGE_NODES = 'WORKFLOW_VISUALIZER_AUTO_ARRANGE_NODES',
  WORKFLOW_VISUALIZER_DEDUPE_EDGES = 'WORKFLOW_VISUALIZER_DEDUPE_EDGES',
  FLOW_DETAIL_SIDE_PANEL = 'FLOW_DETAIL_SIDE_PANEL',
  FLOW_RULE_FILTERS = 'FLOW_RULE_FILTERS',
  FLOW_VALIDATION_RESULTS_FILTERS = 'FLOW_VALIDATION_RESULTS_FILTERS',
  WEBHOOKS_TABLE_PREFERENCES = 'WEBHOOKS_TABLE_PREFERENCES',
  MATCHLIST_CONTENT_TABLE_PREFERENCES = 'MATCHLIST_CONTENT_TABLE_PREFERENCES',
  DEADLINES_CONFIG_TABLE_PREFERENCES = 'DEADLINES_CONFIG_TABLE_PREFERENCES',
  THEME_PREFERENCE = 'THEME_PREFERENCE',
  EDIT_RULE_FLOW_SHOW_GET_STARTED_ALERT = 'EDIT_RULE_FLOW_SHOW_GET_STARTED_ALERT',
  AI_DATA_PIVOT_TABLE = 'AI_DATA_PIVOT_TABLE', // This will be postfixed with an identifier for the pivot table
  AI_DATA_RAW_ACTION_EVENTS_TABLE_PREFERENCES = 'AI_DATA_RAW_ACTION_EVENTS_TABLE_PREFERENCES',
  AI_DATA_RAW_ENTITIES_TABLE_PREFERENCES = 'AI_DATA_RAW_ENTITIES_TABLE_PREFERENCES',
  AI_DATA_RAW_INSTRUMENTS_TABLE_PREFERENCES = 'AI_DATA_RAW_INSTRUMENTS_TABLE_PREFERENCES',
  AI_DATA_RAW_TXN_EVENTS_TABLE_PREFERENCES = 'AI_DATA_RAW_TXN_EVENTS_TABLE_PREFERENCES',
  AI_DATA_RAW_ACTION_EVENTS_TABLE_COLUMNS = 'AI_DATA_RAW_ACTION_EVENTS_TABLE_COLUMNS',
  AI_DATA_RAW_ENTITIES_TABLE_COLUMNS = 'AI_DATA_RAW_ENTITIES_TABLE_COLUMNS',
  AI_DATA_RAW_INSTRUMENTS_TABLE_COLUMNS = 'AI_DATA_RAW_INSTRUMENTS_TABLE_COLUMNS',
  AI_DATA_RAW_TXN_EVENTS_TABLE_COLUMNS = 'AI_DATA_RAW_TXN_EVENTS_TABLE_COLUMNS',
  RULE_ADMIN_SCENARIO_CONFIG_TABLE_COLUMNS = 'RULE_ADMIN_SCENARIO_CONFIG_TABLE_COLUMNS',
  RULE_ADMIN_CONTENT_TABLE_COLUMNS = 'RULE_ADMIN_CONTENT_TABLE_COLUMNS',
  RULE_ADMIN_QUERY_TABLE_COLUMNS = 'RULE_ADMIN_QUERY_TABLE_COLUMNS',
  RULE_ADMIN_EXECUTION_TABLE_COLUMNS = 'RULE_ADMIN_EXECUTION_TABLE_COLUMNS',
  RULE_ADMIN_VALIDATION_TABLE_COLUMNS = 'RULE_ADMIN_VALIDATION_TABLE_COLUMNS',
  RULE_ADMIN_SCHEDULE_TABLE_COLUMNS = 'RULE_ADMIN_SCHEDULE_TABLE_COLUMNS',
  RULE_ADMIN_RISK_MODEL_EXECUTION_TABLE_COLUMNS = 'RULE_ADMIN_RISK_MODEL_EXECUTION_TABLE_COLUMNS',
  RULE_ADMIN_RISK_MODEL_TABLE_COLUMNS = 'RULE_ADMIN_RISK_MODEL_TABLE_COLUMNS',
  RULE_ADMIN_RISK_MODEL_CONFIG_TABLE_COLUMNS = 'RULE_ADMIN_RISK_MODEL_CONFIG_TABLE_COLUMNS',
  RULE_ADMIN_ALERT_CONTENT_TABLE_COLUMNS = 'RULE_ADMIN_ALERT_CONTENT_TABLE_COLUMNS',
  RULE_ADMIN_ALERT_HIT_TABLE_COLUMNS = 'RULE_ADMIN_ALERT_HIT_TABLE_COLUMNS',
  DATA_SETTINGS_TABLE_COLUMNS = 'DATA_SETTINGS_TABLE_COLUMNS',
  AI_ADMIN_TRACKING_TABLE_COLUMNS = 'AI_ADMIN_TRACKING_TABLE_COLUMNS',
  FLOW_HELP_OVERLAY_DISMISSED = 'FLOW_HELP_OVERLAY_DISMISSED',
  RFI_REQUESTS_TABLE_PREFERENCES = 'RFI_REQUESTS_TABLE_PREFERENCES',
  RFI_REQUESTS_FILTERS = 'RFI_REQUESTS_FILTERS',
  RFI_REQUESTS_PINNED_FILTERS = 'RFI_REQUESTS_PINNED_FILTERS',
}
